import { isDocker, isFeature, isPreProduction } from '@/lib/helpers/envHelpers'

export function getApiUrl() {
  if (isFeature()) {
    return import.meta.env.VITE_RQ_API_FEATURE_URL
  }

  if (isPreProduction()) {
    return import.meta.env.VITE_RQ_API_PRE_PRODUCTION_URL
  }

  if (isDocker()) {
    return import.meta.env.VITE_RQ_API_PRIVATE_URL
  }

  return import.meta.env.VITE_RQ_API_URL
}
